<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
            <vs-row>
                <vs-card style="border-radius: 10px;">
                    <div slot="header">
                        <h3 class="card-title mb-0">Búsqueda de empresa</h3>
                    </div>
                    <vs-row>
                        <vs-col vs-lg="8" vs-xs="8" vs-sm="8">
                            <CompanySelector v-model="company" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-xs="4" vs-sm="4">
                            <div class="d-flex ">
                                <vs-button icon="add" class="flex-shrink-0 ml-auto" color="primary"
                                    style="margin-top: 1.5rem;" :disabled="activateButton" @click="newLiquidation()">Agregar
                                    liquidación</vs-button>
                            </div>
                        </vs-col>
                    </vs-row>
                </vs-card>

                <vs-card style="border-radius: 10px;" v-if="showNewLiquidation">
                    <vs-row>
                        <vs-col vs-lg="8" vs-xs="8" vs-sm="8">
                            <h3 class="card-title">{{ titleLiquidation }}</h3>
                        </vs-col>
                    </vs-row>
                    <FormLiquidation v-bind:company=company v-on:cancel="cancel" v-bind:liquidation=selectedLiquidation :newLiquidation=seeNewLiquidation
                        v-on:updateLiquidations="getListLiquidations"></FormLiquidation>
                </vs-card>

                <vs-card style="border-radius: 10px;" v-if="company">
                    <div slot="header">
                        <h3 class="card-title mb-0">Liquidaciones existentes</h3>
                    </div>
                    <vs-table id="liquidation" ref="liquidation" stripe pagination max-items="10" search
                        :data="listLiquidations" class="text-nowrap" noDataText="No se encontraron liquidaciones">
                        <template slot="thead">
                            <vs-th sort-key="id">Id</vs-th>
                            <vs-th sort-key="title">Nombre</vs-th>
                            <vs-th sort-key="modality">Tipo de liquidación</vs-th>
                            <vs-th sort-key="actions">Acciones</vs-th>
                        </template>
                        <template slot-scope="{ data }" v-if="data">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].code" style="width: 100px;"
                                    :class="{ 'chosen': selectedLiquidation != null && selectedLiquidation.code === data[indextr].code }">
                                    <div>
                                        <span class=" badge-pill ">{{ data[indextr].code }}</span>
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextr].title" style="width: 200px;"
                                    :class="{ 'chosen': selectedLiquidation != null && selectedLiquidation.code === data[indextr].code }">
                                    <div>
                                        <span class=" badge-pill ">
                                            {{ data[indextr].title }}
                                        </span>
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextr].liquidationType" style="width: 100px;"
                                    :class="{ 'chosen': selectedLiquidation != null && selectedLiquidation.code === data[indextr].code }">
                                    <div class="d-flex no-block align-items-center">
                                        <div>
                                            <span class=" badge-pill ">
                                                {{ getNameLiquidationType(data[indextr].liquidationType) }}
                                            </span>
                                        </div>
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextr].actions" style="width: 150px;"
                                    :class="{ 'chosen': selectedLiquidation != null && selectedLiquidation.code === data[indextr].code }">
                                    <div class="d-flex align-items-center">
                                        <vs-button color="danger" type="filled" icon="delete" @click="remove(data[indextr])"
                                            style="margin-right: 5px;"></vs-button>
                                        <vs-button color="primary" type="filled" icon="edit"
                                            @click="edit(data[indextr])"></vs-button>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-card>
            </vs-row>
        </vs-col>
    </vs-row>
</template>
<style>
.circulo {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.chosen {
    background-color: #b6e9fd;
}
</style>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FormLiquidation from "./form-liquidation";
import CompanySelector from "@/components/Shared/CompanySelector";
import { confirmation } from "@/global/utils";
import { configToast, TOAST_TYPES } from "@/global/toast";
import { ROUTES } from "@/global/api_routes";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import kind from "@/global/lasting/EKind";

export default {
    name: "CurrentLiquidations",
    components: {
        FormLiquidation,
        CompanySelector
    },

    data: () => ({
        isLoading: false,
        company: null,
        companies: [],
        listLiquidations: [],
        activateButton: true,
        showNewLiquidation: false,
        selectedLiquidation: null,
        titleLiquidation: "Crear liquidación",
        seeNewLiquidation: false,
        liquidationTypes: []
    }),
    watch: {
        company: function () {
            this.getListLiquidations();
            this.activateButton = false;
        },
    },
    mounted() {
        this.getLiquidationTypes();
    },
    methods: {
        toast(message, type = TOAST_TYPES.INFO) {
            const instance = configToast(this, "#liquidation_container");
            return instance.open(message, type);
        },
        getLiquidationTypes() {
            unityEndpoint.getUnityListByKind(kind.LIQUIDATION_TYPES)
                .then(info => this.liquidationTypes = info);
        },
        getListLiquidations() {
            this.$vs.loading()
            this.$http
                .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_LIQUIDATIONS_COMPLETE, {
                    params: {
                        companyId: this.company,
                    },
                })
                .then(({ data }) => {
                    if (data.code > 0) {
                        this.listLiquidations = data.info;
                        return;
                    }
                    this.listLiquidations = [];
                    this.toast("No se han encontrado registros", TOAST_TYPES.ERROR);
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        newLiquidation() {
            this.showNewLiquidation = true;
            this.seeNewLiquidation = true;
        },
        edit(row) {
            this.showNewLiquidation = true;
            this.selectedLiquidation = row;
            this.titleLiquidation = "Editar liquidación"
            this.seeNewLiquidation = false;
        },
        cancel() {
            this.showNewLiquidation = false;
        },
        remove(row) {
            confirmation(this, "¿Deseas elminar la liquidación seleccionada?").then((result) => {
                if (!result) {
                    return;
                }
                this.deleteLiquidation(row);
                this.showNewLiquidation = false;
            });
        },
        getNameLiquidationType(liquidationType) {
            return liquidationType ? this.liquidationTypes.find(e => e.code === liquidationType.code).title : "";
        },
        deleteLiquidation(liquidation) {
            this.$vs.loading()
            this.$http
                .delete(ROUTES.DASHBOARD.LIQUIDATIONS.DELETE, {
                    params: {
                        liquidationCode: liquidation.code,
                    },
                })
                .then(({ data }) => {
                    this.$vs.loading.close();
                    if (data.code > 0) {
                        this.toast(
                            "La liquidación se ha eliminado correctamente",
                            TOAST_TYPES.SUCCESS
                        );
                        this.getListLiquidations();
                        this.selectedLiquidation = null;
                        return;
                    }
                    this.toast(data.message, TOAST_TYPES.ERROR);
                });
        },
    },
};
</script>
